export default (scene) => {

    const width = scene.scale.width;
    const height = scene.scale.height;

    const progressBar = scene.add.graphics();
    const progressBox = scene.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2 - 50, 320, 50);

    const loadingText = scene.make.text({
        x: width / 2,
        y: height / 2 + 50,
        text: 'Loading...',
        style: {
            font: '20px Splurge',
            fill: '#ffffff'
        }
    });
    loadingText.setOrigin(0.5, 0.5);

    scene.load.on('progress', function (value) {
        progressBar.clear();
        progressBar.fillStyle(0xffffff, 1);
        progressBar.fillRect(width / 2 - 160 + 10, height / 2 - 40, 300 * value, 30);
    });

    scene.load.on('complete', function () {
        progressBar.destroy();
        progressBox.destroy();
        loadingText.destroy();
    });

    //scene.load.image('logo', 'zenvalogo.png');
    //for (const i = 0; i < 5000; i++) {
    //    scene.load.image('logo'+i, 'zenvalogo.png');
    //}
}